import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FinalCta } from "@/components/FinalCta";
import { FaqSection } from "@/components/FaqSection";
import { SEOHead } from "@/components/SEOHead";
import { agendar } from "@/components/home/rubro";
import { Link } from "@/lib/router-compat";

// ---------------------------------------------------------------------------
// PRECIOS — "Lo que cuesta, sin vueltas." Single plan + conditions + addons.
// ---------------------------------------------------------------------------

const included = [
  "Sitio web hecho a medida",
  "Ficha de Google optimizada",
  "Inbox unificado de WhatsApp, Instagram y Facebook",
  "Agente IA entrenado con tu tono",
  "Seguimiento automático de presupuestos",
  "Sistema de reseñas después de cada trabajo",
  "Reactivación de clientes anteriores",
  "Reporte semanal por WhatsApp y mail",
  "Soporte por WhatsApp con gente real",
];

const terms = [
  { k: "Precio", v: "$390.000 ARS por mes" },
  { k: "Contrato", v: "Sin permanencia. Cancelás cuando quieras." },
  {
    k: "Garantía",
    v: "30 días. Si no ves mejora, te devolvemos la inversión.",
  },
  { k: "Implementación", v: "7 a 10 días desde la primera llamada." },
  { k: "Forma de pago", v: "Transferencia o tarjeta. Facturación mensual." },
  { k: "Soporte", v: "Por WhatsApp, con gente real, en horario laboral." },
];

const addons = [
  {
    t: "Agente IA",
    d: "Cuando el volumen de consultas supera lo que tu equipo puede atender.",
  },
  {
    t: "Google Ads",
    d: "Pauta en Google para aparecer arriba. Se cotiza según rubro y zona.",
  },
  {
    t: "SEO Avanzado",
    d: "Contenido estratégico para dominar las búsquedas de tu rubro a largo plazo.",
  },
  {
    t: "Optimización de ficha",
    d: "Armado y optimización de tu Google Business Profile para el mapa local.",
  },
];

const Precios = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Precios — Plan Crecé, todo incluido | CreceLocal"
        description="Un solo plan a $390.000 ARS/mes. Sitio web, ficha de Google, reseñas, campañas de WhatsApp, seguimiento e inbox unificado. Sin contrato de permanencia. Garantía de 30 días."
        canonical="/precios"
      />
      <Navbar />
      <main>
        <section
          className="mx-auto px-6 text-center"
          style={{
            maxWidth: 1240,
            paddingTop: "clamp(72px,9vw,120px)",
            paddingBottom: 56,
          }}
        >
          <div
            className="font-mono text-[13px] text-[#A78BFA]"
            style={{ letterSpacing: "0.08em" }}
          >
            PRECIOS
          </div>
          <h1
            className="font-medium text-[#EEEDF2] mt-5"
            style={{
              fontSize: "clamp(44px,6.6vw,92px)",
              lineHeight: 0.98,
              letterSpacing: "-0.03em",
            }}
          >
            Lo que cuesta,{" "}
            <span
              style={{
                background: "linear-gradient(90deg,#A78BFA,#E879F9)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              sin vueltas.
            </span>
          </h1>
          <p className="text-[#BAB6C4] mt-[18px]" style={{ fontSize: 18 }}>
            Un solo plan. Todo incluido. Sin contrato de permanencia.
          </p>
        </section>

        {/* Plan card */}
        <section
          className="mx-auto px-6"
          style={{ maxWidth: 1040, paddingBottom: 72 }}
        >
          <div
            className="grid overflow-hidden rounded-[20px]"
            style={{
              gridTemplateColumns:
                "repeat(auto-fit,minmax(min(100%,360px),1fr))",
              border: "1px solid #4C3A7A",
              background: "#120F1C",
            }}
          >
            <div
              className="p-8 lg:p-12"
              style={{ borderRight: "1px solid #2A2340" }}
            >
              <h2 className="text-[22px] font-semibold text-[#EEEDF2]">
                Plan Crecé
              </h2>
              <p className="text-[#9C98A6] mt-2" style={{ lineHeight: 1.5 }}>
                Lo armamos y lo mantenemos nosotros.
              </p>
              <div
                className="font-semibold text-[#EEEDF2] mt-8"
                style={{
                  fontSize: "clamp(44px,5vw,64px)",
                  letterSpacing: "-0.035em",
                }}
              >
                $390.000
              </div>
              <div className="text-[#9C98A6]">ARS por mes</div>
              <button
                onClick={() => agendar("Precios - Agendar llamada")}
                className="bg-[#7C3AED] hover:bg-[#8B5CF6] text-white font-semibold rounded-[10px] transition-colors w-full"
                style={{ padding: 15, marginTop: 32 }}
              >
                Agendar una llamada
              </button>
              <p className="text-[13.5px] text-[#9C98A6] mt-3 text-center">
                Sin contrato · Cancelás cuando quieras
              </p>
            </div>
            <div className="flex flex-col gap-3.5 p-8 lg:p-12">
              <div
                className="font-mono text-[12px] text-[#9C98A6]"
                style={{ letterSpacing: "0.06em" }}
              >
                INCLUYE
              </div>
              {included.map((x) => (
                <div
                  key={x}
                  className="grid"
                  style={{
                    gridTemplateColumns: "22px 1fr",
                    gap: 6,
                    lineHeight: 1.45,
                  }}
                >
                  <span className="text-[#A78BFA]">✓</span>
                  <span className="text-[#EEEDF2]">{x}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Conditions table */}
        <section
          className="mx-auto px-6"
          style={{ maxWidth: 1040, paddingBottom: 72 }}
        >
          <h2
            className="font-semibold text-[#EEEDF2]"
            style={{
              fontSize: 24,
              letterSpacing: "-0.02em",
            }}
          >
            Las condiciones, en una tabla
          </h2>
          <div className="mt-5 border border-[#221F2A] rounded-[14px] overflow-hidden">
            {terms.map((t) => (
              <div
                key={t.k}
                className="grid"
                style={{
                  gridTemplateColumns: "minmax(140px,1fr) 2fr",
                  gap: 16,
                  padding: "18px 22px",
                  borderBottom: "1px solid #1C1924",
                }}
              >
                <span className="text-[#9C98A6]">{t.k}</span>
                <span className="font-medium text-[#EEEDF2]">{t.v}</span>
              </div>
            ))}
          </div>
          <p className="mt-3.5 text-[14px] text-[#9C98A6]">
            Detalle completo en la{" "}
            <Link
              to="/reembolso"
              className="text-[#A78BFA] hover:text-[#EEEDF2]"
            >
              política de reembolso
            </Link>{" "}
            y los{" "}
            <Link
              to="/terminos"
              className="text-[#A78BFA] hover:text-[#EEEDF2]"
            >
              términos
            </Link>
            .
          </p>
        </section>

        {/* Addons */}
        <section
          className="mx-auto px-6"
          style={{ maxWidth: 1040, paddingBottom: 96 }}
        >
          <h2
            className="font-semibold text-[#EEEDF2]"
            style={{ fontSize: 24, letterSpacing: "-0.02em" }}
          >
            Lo que no incluye
          </h2>
          <p className="text-[#9C98A6] mt-2" style={{ lineHeight: 1.5 }}>
            Se cotiza aparte, y solo después de tener la base del Plan Crecé
            funcionando.
          </p>
          <div
            className="grid mt-6"
            style={{
              gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
              gap: 14,
            }}
          >
            {addons.map((a) => (
              <div
                key={a.t}
                className="rounded-[14px] p-[22px]"
                style={{ border: "1px dashed #332E3E" }}
              >
                <div
                  className="font-mono text-[11px] text-[#9C98A6]"
                  style={{ letterSpacing: "0.06em" }}
                >
                  OPCIONAL
                </div>
                <h3
                  className="font-semibold text-[#EEEDF2] mt-2.5"
                  style={{ fontSize: 17 }}
                >
                  {a.t}
                </h3>
                <p
                  className="text-[14.5px] text-[#9C98A6] mt-1.5"
                  style={{ lineHeight: 1.5 }}
                >
                  {a.d}
                </p>
              </div>
            ))}
          </div>
        </section>

        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
};

export default Precios;
